import styled from 'styled-components';

export const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 18px;
`;